import { useEffect, useState } from 'react'
import api from '@/lib/api'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { PageHeader } from '@/components/ui/page-header'
import { useToast } from '@/components/ui/toast'

export default function Parametros() {
  const toast = useToast()
  const [aliquota, setAliquota] = useState('')
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [msg, setMsg] = useState('')

  useEffect(() => {
    api.get('/parametro').then(({ data }) => {
      setAliquota(data.aliquotaImposto ?? '')
      setLoading(false)
    })
  }, [])

  async function save(e) {
    e.preventDefault()
    setSaving(true)
    setMsg('')
    try {
      await api.put('/parametro', { aliquotaImposto: Number(aliquota) })
      setMsg('Parâmetros salvos com sucesso.')
      toast.success('Parâmetros salvos com sucesso.')
    } catch (err) {
      setMsg(err?.response?.data?.error || 'Erro ao salvar.')
      toast.error('Erro ao salvar parâmetros.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="flex flex-col h-full">
      <PageHeader
        backTo="/cadastro"
        backLabel="Cadastros"
        title="Parâmetros"
        subtitle="Configurações globais do sistema."
      />

      <div className="flex-1 overflow-auto p-6">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Emissão de NF</CardTitle>
          <CardDescription>Valores padrão aplicados na emissão.</CardDescription>
        </CardHeader>
        <CardContent>
          {loading ? (
            <p className="text-muted-foreground text-sm">Carregando...</p>
          ) : (
            <form onSubmit={save} className="space-y-4">
              <div className="space-y-1.5">
                <Label>Alíquota de imposto padrão (%)</Label>
                <Input type="number" step="0.01" value={aliquota} onChange={(e) => setAliquota(e.target.value)} />
                <p className="text-xs text-muted-foreground">Usada como valor inicial na emissão de NF em lote.</p>
              </div>
              {msg && <p className="text-sm text-primary">{msg}</p>}
              <Button type="submit" disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</Button>
            </form>
          )}
        </CardContent>
      </Card>
      </div>
    </div>
  )
}
